module.exports = __webpack_public_path__ + "static/media/word_search.09bb4e49.png";